import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';
import { LoanStatus } from 'src/types/LoanStatus';

export type APIError = ApiFieldError;

export type UpdateLoanStatusPayload = Partial<LoanStatus>;

export type UpdateLoanStatusParams = UpdateLoanStatusPayload;
/**
 * Action Creators
 */

export const actionCreator = actionCreatorFactory(`@@manager/loan_status`);

export const loanStatusRequest = actionCreator('request');

export const loanStatusRequestSuccess = actionCreator<LoanStatus>('success');

export const loanStatusRequestFail = actionCreator<APIError[]>('fail');

export const updateLoanStatusActions = actionCreator.async<
  UpdateLoanStatusParams,
  LoanStatus,
  APIError[]
>(`update`);
